import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Image } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { DatePicker } from 'antd';

/* import function from store folder */
import { setAction } from '../../../store/components/searchSlice';
import { resetModel } from '../../../store/components/modelSlice';

/* import element from component folder */
import Editor from "../../combination/editor";
import Select from '../../../components/select';

/* import element from assecs folder */
import options from '../../../assecs/json/select/message.json';

/* import fetch function */
import { CreateSingleMessage, FetchSourceDetail } from '../../../services/message';

const CreateMessage = () => {
    const { data } = useSelector(state => state.model);
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const [source, setSource] = useState(data);
    const [messageImage, setImage] = useState(null);
    
    const submitHandler = event => {
        event.preventDefault();
        const isValidate = validate();
        
        if (isValidate) {     
            CreateSingleMessage(source).then(response => {
                if (!Object.keys(response).length) {
                    cancelHandler();
                    dispatch(setAction());
                }
            });
        }
    };

    useEffect(() => {
        FetchSourceDetail({ id: data.msgId })
        .then(response => {
            response.sendDate= null
            setSource(response);
        })
        .catch(error => console.log(error));
    }, []);

    const cancelHandler = () => 
        dispatch(resetModel()
    );
    const changHandler = ({target, target: { name, value, files }}) => {
        const _source = Object.assign({}, source);
        
        if (name === 'fcmType')
            delete error.type;
        else
            delete error[name];

        if (value.length) {
            if (name === 'fcmType')
                _source.type = value;
            else
                _source[name] = value;
        }

        if (files) {
            _source[name] = files[0];
            setImage(URL.createObjectURL(files[0]));
            target.value = null;
        }

        setError(error);
        setSource(_source);
    };

    const pickerHandler = dates => {
        let _source = Object.assign({}, source);
        if (!dates){
            delete _source.sendDate;
        } else {
            const sendDate = `${dates.$y}-${dates.$M + 1}-${dates.$D} ${dates.$H}:${dates.$m}:${dates.$s}`;
            let _sendDate =new Date(sendDate);
            if ((_sendDate.getTime() < new Date().getTime())){
               delete _source.sendDate;
             }

            _source.sendDate = _sendDate.getTime();
            delete error['sendDate'];
            
        }
        setError(error);
        setSource(_source);
    };

    const validate = () => {
        const checkLists = ['msgName', 'type', 'target', 'sendDate','descriptionEnglish'];
        const _errors = {};
        
        checkLists.map( list => (
            (!source[list]) && ( _errors[list] = true)
        ));
        
        if (Object.keys(_errors).length) {
            setError(_errors);
            return false;
        }

        return true;
    };

    const clearImage = () => {
        const _source = Object.assign({}, source);

        delete _source.image;
        
        setImage(null);
        setSource(_source);
    };

    const renderFileExtensionMessage = () => {
        if (!messageImage) {
            return (
                    <div className='label small'>Please select a file with a .jpeg or .png extension.</div>
            );
        }
        return null;
    };
    
    return (
        <Modal show={ true } centered size='lg'>
            <Modal.Header>Create data</Modal.Header>
            <Modal.Body>
                <Form className="modal-form-container" >
                    <div className="form-item">
                        <div className='label'>Name</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='msgName' placeholder='Please enter the message name.' defaultValue={ source.msgName } is-required={`${error.msgName}`} onChange={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Type</div>
                        <span className='semicolon'>：</span>
                        <Select name='fcmType' select_all={ false } shadow={ false } required={ error.type } label={source.typeLabel} _default={ source.type } changHandle={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Target</div>
                        <span className='semicolon'>：</span>
                        <Select name='target' select_all={ false } shadow={ false } options={ options.target } _default={ source.target } required={ error.target } changHandle={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Send Date</div>
                        <span className='semicolon'>：</span>
                        <DatePicker name='sendDate' className='form-picker' showTime status={ (error['sendDate']) && 'error' }  onChange={ pickerHandler } placeholder='Please pick the future time' />
                    </div>
                    <div className="form-item">
                        <div className='label'>Image</div>
                        <span className='semicolon'>：</span>
                        <div className="button-group">
                            <label className='btn' is-required={ `${error.newMonsterPhoto}` }>
                                <span>Choose File</span>
                                <input type="file" name='image' accept="image/png, image/jpeg" hidden onChange={ changHandler } />
                            </label> 
                            <Button type="button" onClick={ clearImage }>Unchoose File</Button>
                            {renderFileExtensionMessage()}
                        </div>
                    </div>
                    <div className="form-item form-image-item">
                        { messageImage && <Image src={ messageImage } /> }
                    </div>
                    <div className="form-item">
                        <Editor source={ source } changeHandle={ changHandler } />
                    </div>
                    <div className="button-container">
                        <Button type="button" data-shadow onClick={ cancelHandler }>Cancel</Button>
                        <Button type="button" data-shadow onClick={ submitHandler }>Submit</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default CreateMessage;